import moment from 'moment-timezone';
import { Logger } from './logger';
import { useUserStore } from '@/stores/user';
import { getPartnerHost } from '@/util/partner-host';

export const Helper = {
  methods: {
    calculateAge(dateString) {
      let dob = new Date(dateString);
      let today = new Date();

      let diff = (today.getTime() - (dob || today).getTime()) / 1000;

      diff /= 60 * 60 * 24;

      if (isNaN(diff)) return 1;
      // returns
      // Positive Float === Past
      // Negative Float === Future
      return diff;
    },

    getGeneralEnrollmentMode(courseType) {
      return (courseType || '').toLowerCase() === 'audit' ? 'audit' : 'honor';
    },

    today() {
      let date = new Date();
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');

      return [date.getFullYear(), month, day].join('-');
    },

    differenceDate(date1, date2) {
      const d1 = new Date(date1);
      const d2 = new Date(date2);
      const diffTime = Math.abs(d2 - d1);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },

    navigateToURL(URL) {
      window.open(URL, '_blank');
    },

    changeTextToSentenseCase(formModel) {
      if (formModel && formModel.firstName) {
        this.formModel.firstName = this.formModel.firstName.replace(/\b\w/g, (l) => l.toUpperCase());
      }
      if (formModel && formModel.lastName) {
        this.formModel.lastName = this.formModel.lastName.replace(/\b\w/g, (l) => l.toUpperCase());
      }
      if (formModel && formModel.mailingAddress && formModel.mailingAddress.city) {
        this.formModel.mailingAddress.city = this.formModel.mailingAddress.city.replace(/\b\w/g, (l) =>
          l.toUpperCase()
        );
      }
    },

    checkLanguage(e) {
      if (!/^[A-Za-z0-9 ]*$/.test(e.key)) {
        e.preventDefault();
      }
    },

    checkEmailLanguage(e) {
      if (!/^[a-zA-Z0-9_.@+-]*$/.test(e.key)) {
        e.preventDefault();
      }
    },

    checkLanguageforAddress(e) {
      if (!/^[A-Za-z0-9 /-]*$/.test(e.key)) {
        e.preventDefault();
      }
    },

    onPasteCheckLanguageforFirstname() {
      if (!/^[A-Za-z0-9 ]*$/.test(this.formModel.firstName)) {
        this.formModel.firstName = '';
      }
    },

    onPasteCheckLanguageforLastname(e) {
      if (!/^[A-Za-z0-9 ]*$/.test(e)) {
        this.formModel.lastName = '';
      }
    },

    onPasteCheckLanguageforEmail(e) {
      if (!/^[a-zA-Z0-9_.@+-]*$/.test(e)) {
        this.formModel.email = '';
      }
    },

    onPasteCheckLanguageforCity(e) {
      if (!/^[A-Za-z0-9 ]*$/.test(e)) {
        this.formModel.mailingAddress.city = '';
      }
    },

    onPasteCheckLanguageforState(e) {
      if (!/^[A-Za-z0-9 ]*$/.test(e)) {
        this.formModel.mailingAddress.state = '';
      }
    },

    onPasteCheckLanguageforZipcode(e) {
      if (!/^[A-Za-z0-9 ]*$/.test(e)) {
        this.formModel.mailingAddress.zipCode = '';
      }
    },

    onPasteCheckLanguageforCountry(e) {
      if (!/^[A-Za-z0-9 ]*$/.test(e)) {
        this.formModel.mailingAddress.country = '';
      }
    },

    getItemFromLocalStorage(key) {
      return localStorage.getItem(key);
    },

    calculateLearnersAge(learnerDOB) {
      const today = new Date();
      const learnersBirthDate = new Date(learnerDOB);
      let learnersAge = today.getFullYear() - learnersBirthDate.getFullYear();
      const birthdayMonth = today.getMonth() - learnersBirthDate.getMonth();

      if (birthdayMonth < 0 || (birthdayMonth === 0 && today.getDate() < learnersBirthDate.getDate())) {
        learnersAge--;
      }

      return learnersAge;
    },

    calculateMandatePathwayCourse(pathwayData, learnerDOB) {
      if (!pathwayData) return;

      return pathwayData._credits.includes('-') && this.calculateLearnersAge(learnerDOB) > 22 ? 4 : 8;
    },
    getInProgressCredits(courses) {
      let totalCredits = 0;
      const processedCourses = [];

      for (const course of courses) {
        const courseAttempts = this.checkIFCourseHasMultipleAttempts(course, processedCourses);

        if (!courseAttempts && course._buttonAction !== 'Add to Transcript') {
          const credits = (course._courseInfo || {})._asuCredits || 0;
          totalCredits += credits;
          processedCourses.push(course);
        }
      }

      return totalCredits;
    },

    checkIFCourseHasMultipleAttempts(course, courses) {
      let res = courses.find(
        (e) =>
          (e._courseInfo || {})._courseName === (course._courseInfo || {})._courseName &&
          (e._courseInfo || {})._coursePrefix === (course._courseInfo || {})._coursePrefix
      );

      return res;
    },

    getCompletedCredits(courses) {
      let totalCredits = 0;
      let processedCourses = [];

      (courses || []).forEach((course) => {
        const courseAttempts = this.checkIFCourseHasMultipleAttempts(course, processedCourses);

        if (!courseAttempts) {
          totalCredits += (course._courseInfo || {})._asuCredits || 0;
          processedCourses.push(course);
        }
      });

      return totalCredits;
    },
    getRemainingCredits(notOpenCourses, openCourses) {
      let totalNotOpenCourses = 0;
      let totalOpenCourses = 0;
      (notOpenCourses || []).forEach((course) => {
        totalNotOpenCourses += course._asuCredits;
      });
      (openCourses || []).forEach((course) => {
        totalOpenCourses += (course._courseOfferingData[0] || [])._asuCredits || 0;
      });

      return totalNotOpenCourses + totalOpenCourses;
    },
    processPathwaysCreditoutof() {
      const userStore = useUserStore();
      return this.pathwaysCredit
        ? parseInt(this.pathwayData._credits) || 0
        : this.calculateLearnersAge(userStore.apis.learnerData._birthDate) > 22
          ? parseInt((this.pathwayData._credits || '').split('-')[0]) || 0
          : parseInt((this.pathwayData._credits || '').split('-')[1]) || 0;
    },
    dateFormatUS(date) {
      if (!date || date.length !== 10) return '';

      // Expected input "2000-12-10" and returns 12-10-2000
      return [date.slice(5, 7), date.slice(8, 12), date.slice(0, 4)].join('-');
    },
    addTeeDaysToDate(date, days) {
      let updatedDate = new Date(date);

      updatedDate.setDate(updatedDate.getDate() + days);

      return updatedDate;
    },

    getCourseEnrollmentDate(course) {
      // OS-4486 Update start dates that show for upcoming Continuous course types
      const TODAY = new Date();
      if ((course._courseType || '').toLowerCase() === 'continuous' && new Date(course._courseStartDate) > TODAY) {
        let date = new Date(course._courseStartDate);
        return [date.getMonth() + 1, date.getDate(), date.getFullYear()].join('/');
      } else {
        return this.today();
      }
    },

    sortCoursesWithStartDate(courseA, courseB) {
      if ((((courseA || {})._courseInfo || {})._courseType || '').toLowerCase() === 'continuous') {
        ((courseA || {})._courseInfo || {})._courseStartDate = new Date().toLocaleString().split(',')[0];
      }

      if ((((courseB || {})._courseInfo || {})._courseType || '').toLowerCase() === 'continuous') {
        ((courseB || {})._courseInfo || {})._courseStartDate = new Date().toLocaleString().split(',')[0];
      }

      if (
        new Date(((courseA || {})._courseInfo || {})._courseStartDate || '') <
        new Date(((courseB || {})._courseInfo || {})._courseStartDate || '')
      ) {
        return -1;
      }

      if (
        new Date(((courseA || {})._courseInfo || {})._courseStartDate || '') >
        new Date(((courseB || {})._courseInfo || {})._courseStartDate || '')
      ) {
        return 1;
      }
      // If the learner is enrolled in more than one course with the same start date,
      // they can be listed alphabetically (secondary to being in chronological order)
      return (((courseA || {})._courseInfo || {})._courseName || '').localeCompare(
        ((courseB || {})._courseInfo || {})._courseName || ''
      );
    },

    sortCurrentCourses(courseA, courseB) {
      if ((((courseA || {})._courseInfo || {})._courseType || '').toLowerCase() === 'continuous') {
        ((courseA || {})._courseInfo || {})._courseStartDate = (
          (courseA || {})._courseInfo || {}
        )._courseRegistrationDate;
      }

      if ((((courseB || {})._courseInfo || {})._courseType || '').toLowerCase() === 'continuous') {
        ((courseB || {})._courseInfo || {})._courseStartDate = (
          (courseB || {})._courseInfo || {}
        )._courseRegistrationDate;
      }

      if (
        new Date(((courseA || {})._courseInfo || {})._courseStartDate || '') <
        new Date(((courseB || {})._courseInfo || {})._courseStartDate || '')
      ) {
        return -1;
      }

      if (
        new Date(((courseA || {})._courseInfo || {})._courseStartDate || '') >
        new Date(((courseB || {})._courseInfo || {})._courseStartDate || '')
      ) {
        return 1;
      }
      // If the learner is enrolled in more than one course with the same start date,
      // they can be listed alphabetically (secondary to being in chronological order)
      return (((courseA || {})._courseInfo || {})._courseName || '').localeCompare(
        ((courseB || {})._courseInfo || {})._courseName || ''
      );
    },

    getCaller() {
      Logger.methods.logInfo('getCaller');

      let callerName = '';
      try {
        // Modified stackTraceLimit because the function name wasn't within the limit
        Error.stackTraceLimit = 15;

        throw new Error();
      } catch (e) {
        try {
          Logger.methods.logInfo('getCaller catch error ', e);
          const st = e.stack;
          const stackList = (st || '').split('at ');

          const matchedStack = stackList.filter((stack) => stack.includes('ConnectorService'));

          callerName = (matchedStack[matchedStack.length - 1] || '').split(' ')[0];
          // eslint-disable-next-line no-empty
        } catch (error) {}
      }
      return callerName;
    },

    getLearnersJourney(callerName, path) {
      return `${callerName + '_' + path}`;
    },

    setJourneyInResoursePath(apiPath, journey, defaultJourney) {
      return apiPath + (apiPath.includes('?') ? '&journey=' : '?journey=') + (journey || defaultJourney);
    },
    setCertificatesInResoursePath(apiPath, certificateCredentials) {
      const queryString = certificateCredentials
        .map((cert) => `certificateTypes=${encodeURIComponent(cert)}`)
        .join('&');
      return apiPath + (apiPath.includes('?') ? '&' : '?') + queryString + '&parentType=Accelerate';
    },

    setJourneyInBody(body, journey, defaultJourney) {
      body.journey = journey || defaultJourney;
    },

    sortCoursesWithAuditType(courses) {
      return (courses || []).sort((a) => {
        return a._courseInfo && a._courseInfo._courseType.toLowerCase() !== 'audit' ? 1 : -1;
      });
    },

    isEligibleForRefund(course) {
      let isEligible = false;

      if (course) {
        const today = moment().tz('America/Phoenix').format(); //No matter which timezone user is in, to compare always with current MST
        const em = (course.enrollmentMode || course._enrollmentMode || '').toLowerCase();
        const courseDropDeadLineNoOfDays = course.courseDropDeadline || course._courseDropDeadline || 0;
        const continuousCourseTypeStartDate = course.enrollmentModeVerifiedDate || course._enrollmentModeVerifiedDate;
        const standardCourseTypeStartDate = course.courseStartDate || course._courseStartDate;
        const courseType = (course.courseType || course._courseType || '').toLowerCase();

        const date =
          courseType === 'continuous' || courseType === 'audit'
            ? continuousCourseTypeStartDate && moment(continuousCourseTypeStartDate.split('T')[0])
            : standardCourseTypeStartDate && moment(standardCourseTypeStartDate, 'MM/DD/YYYY');

        if (date) {
          const courseDropDeadlineDate = moment(date).add(courseDropDeadLineNoOfDays, 'days').format(); //Note: to end deadline on next day at 12:00 AM

          isEligible = em === 'verified' && today <= courseDropDeadlineDate;
        }
      }

      return isEligible;
    },
    isUlcPartner() {
      const hostname = getPartnerHost().split(':')[0]; // drop port, as location.hostname
      const parts = hostname.split('.');
      const domain = parts[1]; // Get the domain

      return domain === 'ulc';
    },
    isAcceleratePartner(partnerURLSubDomain) {
      // Check for accelerate partner
      return partnerURLSubDomain === 'accelerate';
    }
  },

  constants: {
    creditRequestGradeTooLow:
      'There has been an error with your request for credit. Please contact support for assistance.',
    creditRequestGradeChangeMessage: 'Your grade has changed, please try again',
    creditRequestCourseIncorrectlySetup: 'Oops, there was an issue looking up your course. Please contact support.',
    alreadyPurchasedMessage: 'This course fee has already been purchased. Please return to your learner dashboard.'
  }
};
